import {
  doGETRequest,
  doPATCHRequest,
  doPOSTRequest,
  doPUTRequest,
} from "./Api";

class ProductItemApi {

  public static async listOne(productItemId:any) {
    const relativePath = "/product-item/"+productItemId;
    var response = await doGETRequest(relativePath);
    return response;
  }
  
  public static async listAll() {
    const relativePath = "/product-item";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async deactivate(id: number) {
    return await doPATCHRequest(`/product-item/${id}/passive`, {});
  }

  public static async reactivate(id: number) {
    return await doPATCHRequest(`/product-item/${id}/activate`, {});
  }

  public static async listPaged(search: string = "", page: number = 0, size: number = 50) {
    const qs = new URLSearchParams({ search: search || "", page: String(page), size: String(size) });
    return await doGETRequest(`/product-item/paged?${qs.toString()}`);
  }

  public static async listPagedPassive(search: string = "", page: number = 0, size: number = 50) {
    const qs = new URLSearchParams({ search: search || "", page: String(page), size: String(size) });
    return await doGETRequest(`/product-item/paged-passive?${qs.toString()}`);
  }

  public static async listAllByPackagingGroup(packagingGroup:any) {
    const relativePath = "/product-item?packagingGroup="+packagingGroup;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAllByPackagingGroupAndWarehouseStockType(packagingGroup: any, warehouseStockType: any) {
      const relativePath = `/product-item?packagingGroup=${packagingGroup}&warehouseStockType=${warehouseStockType}`;
      const response = await doGETRequest(relativePath);
      return response;
  }

  public static async listAllByFilters(packagingGroup:any, warehouseStockType:any, warehouse:any, onlyNonZeros:any = false) {
      const relativePath = `/product-item?packagingGroup=${packagingGroup}&warehouseStockType=${warehouseStockType}&warehouseName=${warehouse}&onlyNonZeros=${onlyNonZeros}`;
      const response = await doGETRequest(relativePath);
      return response;
  }

  // Filtreler + arama + sayfalama bir arada (mal giris/cikis, stok yonetimi sayfalari)
  public static async listFilteredPaged(packagingGroup:any, warehouseStockType:any, warehouse:any, onlyNonZeros:any = false, search: string = "", page: number = 0, size: number = 50) {
      const qs = new URLSearchParams({
        packagingGroup: packagingGroup ?? "",
        warehouseStockType: warehouseStockType ?? "",
        warehouseName: warehouse ?? "",
        onlyNonZeros: String(onlyNonZeros ?? false),
        search: search || "",
        page: String(page),
        size: String(size),
      });
      return await doGETRequest(`/product-item/filtered-paged?${qs.toString()}`);
  }

  public static async listPackagingGroups() {
    const relativePath = "/product-item/packagingGroups";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listWarehouseStockTypes() {
      const relativePath = "/product-item/warehouseStockType";
      var response = await doGETRequest(relativePath);
      return response;
  }

  public static async listWarehouses() {
    const relativePath = "/warehouses/names";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async createOrUpdateProductItemPool(requestDTO: any) {
    if (requestDTO.id) {
      return await this.updateNewProductItemPool(requestDTO);
    } else {
      return await this.createNewProductItemPool(requestDTO);
    }
  }

   public static async synchronizeProductItems() {
       const relativePath = "/product-item/synchronize";

       const response = await doGETRequest(relativePath);
       return response;
   }

   public static async synchronizeStatus() {
       return await doGETRequest("/product-item/synchronize/status");
   }

  public static async createNewProductItemPool(requestDTO: any) {
    const relativePath = "/product-item";
    var response = await doPOSTRequest(relativePath, requestDTO);
    return response;
  }

  public static async updateNewProductItemPool(requestDTO: any) {
    const relativePath = "/product-item";
    var response = await doPUTRequest(relativePath, requestDTO);
    return response;
  }

  public static async updateProductItemPoolStock(requestDTO: any) {
    const relativePath = "/product-item/stock";
    var response = await doPATCHRequest(relativePath, requestDTO);
    return response;
  }

  public static async updateProductItemPoolStockBulk(requestDTO: any) {
    const relativePath = "/product-item/stock-bulk";
    var response = await doPATCHRequest(relativePath, requestDTO);
    return response;
  }

  public static async stockImport(requestDTO: any) {
    const relativePath = "/product-item/stock-import";
    var response = await doPATCHRequest(relativePath, requestDTO);
    return response;
  }

  public static async stockExport(requestDTO: any) {
    const relativePath = "/product-item/stock-export";
    var response = await doPATCHRequest(relativePath, requestDTO);
    return response;
  }

  public static async stockImportBulk(requestDTO: any) {
    const relativePath = "/product-item/stock-import-bulk";
    var response = await doPATCHRequest(relativePath, requestDTO);
    return response;
  }

  public static async stockExportBulk(requestDTO: any) {
    const relativePath = "/product-item/stock-export-bulk";
    var response = await doPATCHRequest(relativePath, requestDTO);
    return response;
  }

  /*public static async listStockHistory(productItemId: any, warehouse?: any) {
    const relativePath = "/product-item/stock-history/"+productItemId + (warehouse && "?warehouse="+warehouse || "");
    var response = await doGETRequest(relativePath);
    return response;
  }*/
  public static async listStockHistory(filters: {
      productItemId?: any;
      warehouseId?: any;
      action?: string;
      startDate?: string;
      endDate?: string;
  }) {
      let queryParams = new URLSearchParams();

      if (filters.productItemId) {
          queryParams.append("productItemId", filters.productItemId);
      }
      if (filters.warehouseId) {
          queryParams.append("warehouseId", filters.warehouseId);
      }
      if (filters.action) {
          queryParams.append("action", filters.action);
      }
      if (filters.startDate) {
          queryParams.append("startDate", filters.startDate);
      }
      if (filters.endDate) {
          queryParams.append("endDate", filters.endDate);
      }

      const relativePath = "/product-item/stock-history" + (queryParams.toString() ? `?${queryParams.toString()}` : "");

      const response = await doGETRequest(relativePath);
      return response;
  }

}

export default ProductItemApi;
